<template>
  <svg
    width="122"
    height="100"
    viewBox="0 0 122 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M61.1033 99.4921C85.737 99.4921 105.707 95.7608 105.707 91.1579C105.707 86.5551 85.737 82.8237 61.1033 82.8237C36.4696 82.8237 16.5 86.5551 16.5 91.1579C16.5 95.7608 36.4696 99.4921 61.1033 99.4921Z"
      fill="#F5F5F7"
      fill-opacity="0.8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M96.7856 66.6734L81.0455 47.3017C80.2902 46.3899 79.1863 45.8379 78.0238 45.8379H44.1817C43.0198 45.8379 41.9159 46.3899 41.1606 47.3017L25.4211 66.6734V76.7938H96.7863V66.6734H96.7856Z"
      fill="#AEB8C2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M38.7566 20.8354H83.4493C84.1473 20.8354 84.8166 21.1127 85.3102 21.6062C85.8037 22.0997 86.0809 22.7691 86.0809 23.467V84.8775C86.0809 85.5755 85.8037 86.2448 85.3102 86.7383C84.8166 87.2319 84.1473 87.5091 83.4493 87.5091H38.7566C38.0586 87.5091 37.3893 87.2319 36.8958 86.7383C36.4023 86.2448 36.125 85.5755 36.125 84.8775V23.467C36.125 22.7691 36.4023 22.0997 36.8958 21.6062C37.3893 21.1127 38.0586 20.8354 38.7566 20.8354V20.8354Z"
      fill="#F5F5F7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M44.5777 27.3833H77.6283C77.9773 27.3833 78.312 27.5219 78.5587 27.7687C78.8055 28.0154 78.9441 28.3501 78.9441 28.6991V45.1182C78.9441 45.4671 78.8055 45.8018 78.5587 46.0486C78.312 46.2953 77.9773 46.434 77.6283 46.434H44.5777C44.2287 46.434 43.894 46.2953 43.6472 46.0486C43.4005 45.8018 43.2619 45.4671 43.2619 45.1182V28.6991C43.2619 28.3501 43.4005 28.0154 43.6472 27.7687C43.894 27.5219 44.2287 27.3833 44.5777 27.3833ZM44.75 53.5767H77.4559C77.8506 53.5767 78.2291 53.7335 78.5082 54.0126C78.7873 54.2917 78.9441 54.6702 78.9441 55.0649C78.9441 55.4596 78.7873 55.8381 78.5082 56.1172C78.2291 56.3962 77.8506 56.553 77.4559 56.553H44.75C44.3553 56.553 43.9768 56.3962 43.6977 56.1172C43.4186 55.8381 43.2619 55.4596 43.2619 55.0649C43.2619 54.6702 43.4186 54.2917 43.6977 54.0126C43.9768 53.7335 44.3553 53.5767 44.75 53.5767ZM44.75 61.3155H77.4559C77.8507 61.3155 78.2293 61.4724 78.5085 61.7515C78.7876 62.0307 78.9444 62.4093 78.9444 62.804C78.9444 63.1988 78.7876 63.5774 78.5085 63.8565C78.2293 64.1357 77.8507 64.2925 77.4559 64.2925H44.75C44.3552 64.2925 43.9766 64.1357 43.6975 63.8565C43.4184 63.5774 43.2615 63.1988 43.2615 62.804C43.2615 62.4093 43.4184 62.0307 43.6975 61.7515C43.9766 61.4724 44.3552 61.3155 44.75 61.3155ZM96.6402 89.9353C96.1303 91.9557 94.3395 93.4616 92.2092 93.4616H29.9967C27.8665 93.4616 26.0757 91.955 25.5665 89.9353C25.4693 89.5503 25.4203 89.1547 25.4204 88.7576V66.6741H42.7349C44.6474 66.6741 46.1888 68.2846 46.1888 70.2399V70.2662C46.1888 72.2208 47.748 73.7991 49.6605 73.7991H72.5454C74.4579 73.7991 76.0171 72.2063 76.0171 70.2511V70.2432C76.0171 68.2879 77.5586 66.6734 79.4711 66.6734H96.7855V88.7583C96.7855 89.1642 96.7349 89.5583 96.6402 89.9353Z"
      fill="#DCE0E6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M98.8164 21.9026L94.323 23.6461C94.2075 23.6909 94.0818 23.7023 93.9602 23.6789C93.8385 23.6555 93.726 23.5982 93.6355 23.5137C93.545 23.4292 93.4802 23.3208 93.4485 23.2011C93.4168 23.0813 93.4196 22.9551 93.4565 22.8368L94.7309 18.7533C93.0276 16.8164 92.0276 14.4546 92.0276 11.9059C92.0276 5.33026 98.6842 0 106.896 0C115.106 0 121.763 5.33026 121.763 11.9059C121.763 18.4816 115.107 23.8118 106.895 23.8118C103.916 23.8118 101.143 23.1105 98.8164 21.9026Z"
      fill="#DCE0E6"
    />
    <path
      d="M112.753 14.056C113.788 14.056 114.627 13.2268 114.627 12.204C114.627 11.1812 113.788 10.3521 112.753 10.3521C111.718 10.3521 110.878 11.1812 110.878 12.204C110.878 13.2268 111.718 14.056 112.753 14.056Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M102.913 13.8243H99.1646L101.071 10.5835L102.913 13.8243ZM105.256 10.5835H108.536V13.8243H105.256V10.5835Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {

}
</script>

<style>
</style>


// WEBPACK FOOTER //
// Empty.vue?1a9a9fac